import { render, staticRenderFns } from "./CustomPic.vue?vue&type=template&id=1e952cf2&scoped=true&slot=pic"
import script from "./CustomPic.vue?vue&type=script&lang=js"
export * from "./CustomPic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e952cf2",
  null
  
)

export default component.exports